import React from "react";

function SlaReportItemRepeat({handleInputChange, data, fnc, index}){
    return(
        <>
            <td className={"fieldset-td-sla"} style={{padding: "5px 1rem"}}>
                <input
                    type={"text"}
                    className={`sla-basic-input focus w-full`}
                    value={data.checkResult}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                            handleInputChange(fnc, value, index, "checkResult");
                        }
                    }}
                />
            </td>
            <td className={"fieldset-td-sla"} style={{padding: "5px 1rem"}}>
                <input
                    type={"text"}
                    className={`sla-basic-input focus w-full`}
                    value={data.checkValue}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                            handleInputChange(fnc, value, index, "checkValue");
                        }
                    }}
                />
            </td>
            <td className={"fieldset-td-sla"} style={{padding: "5px 1rem"}}>
                <input
                    type={"text"}
                    className={`sla-basic-input focus w-full`}
                    value={data.customerCheckResult}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                            handleInputChange(fnc, value, index, "customerCheckResult");
                        }
                    }}
                />
            </td>
            <td className={"fieldset-td-sla"} style={{padding: "5px 1rem"}}>
                <input
                    type={"text"}
                    className={`sla-basic-input focus w-full`}
                    value={data.customerCheckValue}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                            handleInputChange(fnc, value, index, "customerCheckValue");
                        }
                    }}
                />
            </td>
            <td className={"fieldset-td-sla"} style={{padding: "5px 1rem"}}>
                <input
                    type={"text"}
                    className={`sla-basic-input focus w-full`}
                    value={data.etc || ""}
                    onChange={(e) => {
                        const value = e.target.value;
                        handleInputChange(fnc, value, index, "etc");
                    }}
                />
            </td>
        </>
    )
}

export {SlaReportItemRepeat}